// セレクトボックスタイプで、大人必須で購入可能なチケット
export const checkCanBuyWithoutAdult = (id) => {
  /* 
  241,生田緑地おでかけチケット(日本民家園入園券＋川崎市バス１日乗車券)
  538,東海バスフリーきっぷ「伊豆高原・城ケ崎１日券」
  540,東海バスフリーきっぷ「全線３日券」
  542,東海バスフリーきっぷ「下田２日券」
  544,東海バスフリーきっぷ「石廊崎・下田２日券」
  545,東海バスフリーきっぷ「堂ヶ島・松崎・石廊崎２日券」
  548,東海バスフリーきっぷ「熱海１日券」
  549,東海バスフリーきっぷ「三島１日券」（みしまるきっぷ）
  550,東海バスフリーきっぷ「伊東・伊豆高原２日券」
  573,東海バスフリーきっぷ「全線２日券」
  */
  const masterBookIdsCanAccompaniedByAnAdult = [
    241, 538, 540, 542, 544, 545, 548, 549, 550, 573,
  ];
  return !masterBookIdsCanAccompaniedByAnAdult.includes(id);
};
